<script>

    /**
     *
     */
    export default {
    };
</script>


<template>
    <!-- Photoswipe Container Markup -->

    <!--  Root element of PhotoSwipe. Must have class pswp. -->
    <div id="photoswipeMarkup" class="pswp" tabindex="-1" role="dialog" aria-hidden="true">

        <!--  Background of PhotoSwipe.
            It's a separate element as animating opacity is faster than rgba(). -->
        <div class="pswp__bg"></div>

        <!--  Slides wrapper with overflow:hidden. -->
        <div class="pswp__scroll-wrap">

            <!--  Container that holds slides.
                PhotoSwipe keeps only 3 of them in the DOM to save memory.
                Don't modify these 3 pswp__item elements, data is added later on. -->
            <div class="pswp__container">
                <div class="pswp__item"></div>
                <div class="pswp__item"></div>
                <div class="pswp__item"></div>
            </div>

            <button class="photoswipeUI-arrowLeft"></button>
            <button class="photoswipeUI-arrowRight"></button>

            <button class="photoswipeUI-closeButton">
                <span></span>
                <span></span>
            </button>

            <!-- Custom Photoswipe UI -->
            <div class="photoswipeUI">

                <div class="photoswipeUI-bottom">
                    <div class="photoswipeUI-bottomContainer">
                        <div class="photoswipeUI-bottomInner">
                            <div class="photoswipeUI-counter">
                                <div class="photoswipeUI-counterInner"></div>
                            </div>
                            <div class="photoswipeUI-captions"></div>
                        </div>
                    </div>
                </div>

            </div>


        </div>

    </div>

</template>
